import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { api_url } from '../Constants/api_constant';
import { handleResponse } from '../Utils/responseHandler';
import logResponse from '../Utils/logger';

import Logo from '../logo.png';

const SubscriberLogin = () => {
  const [usernameOrEmail, setUsernameOrEmail] = useState('99290775');
  const [password, setPassword] = useState('');
  const [referalUrl, setReferalUrl] = useState('https://frontend.theloginhub.eu/subscriber/login');
  const [apikey, setApikey] = useState("FE187DDAC6B5974C8D84C9814F321");
  const [method, setMethod] = useState("vipps");
  const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const getCompanies = async() =>{
    let res = await fetch(api_url.API_URL + 'companies/', {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    });
    let resJson = await res.json();
    var data = [];
    resJson.data.forEach(element => {
      data.push([element.name_firma,element.apikey]);
    });
    console.log(data)
    return data;
  }

  useEffect(() => {
    var data = getCompanies();
    console.log(data);
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    const loginData = {
      email: usernameOrEmail,
      password: password,
      referalUrl: (referalUrl)? 'https://dittmagasin.no/api/info-token': referalUrl,
    };
    let loginMethod = (method)? method:'';
    var loginUrl = '';
    console.log(loginMethod)
    if(loginMethod.length > 0) {
      loginUrl = api_url.API_URL + 'login' + '?method='+ loginMethod;
    } else {
      loginUrl = api_url.API_URL + 'login';
    }
    console.log(loginUrl)
    try {
      
      let res = await
        axios({
          method: 'post',
          url: loginUrl,
          data: {
            email: usernameOrEmail,
            password: password,
            referalUrl: 'https://frontend.theloginhub.eu/subscriber/login'
          },
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'apikey': apikey
          },
        });
        
      let response = res;

      if (response.status == 200) {
        if (response.data.data.token) {
          setMessage(response.data.data.token)
          setErrorMessage('')
        }
        if (response.data.data.url) {
          window.location.replace(response.data.data.url);
          setErrorMessage('')
        }
      } else {
        setErrorMessage(response.error.data.data.toUpperCase())
        setMessage('')
      }
    } catch (error) {
      console.log(error.response.data.data)
      setErrorMessage(error.response.data.data)
      setMessage('')
    }
  };

  return (
    <div className="container-fluid page-body-wrapper full-page-wrapper">
      <div className="content-wrapper d-flex align-items-center">
        <div className="row w-75 m-auto">
          <div className="col-lg-5 mx-auto">
            <div className="auth-form-light text-center px-sm-5"></div>
            <div className='card p-5'>
              {
                message && <div className='alert alert-info'>{message}</div>
              }
              {
                errorMessage && <div className='alert alert-danger'>{errorMessage}</div>
              }

              <form onSubmit={handleLogin} className="pt-3 card">
              <div className="brand-logo">
                    <img src={Logo} alt="logo"/>
                  </div>
                <div className="form-group">
                  <input type="hidden" className='form-control' placeholder="Phone Number" value={usernameOrEmail} onChange={(e) => setUsernameOrEmail(e.target.value)} />
                </div>
                    <input type="hidden" className='form-control' placeholder="apikey" value={apikey} onChange={(e) => setApikey(e.target.value)} />
                    <input type="hidden" className='form-control' placeholder="method" value={method} onChange={(e) => setMethod(e.target.value)} />
                    <button type="submit" className='btn btn-block vipps_link'>
                        Continue on  <img src="https://fsonline.no/logo/vipps.png" />
                    </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriberLogin;
